import { Component, OnInit, Input } from '@angular/core';
import { Status } from 'models';

@Component({
  selector: 'app-timeline-incident',
  template: require('./timeline-incident.component.html'),
  styles: [require('./timeline-incident.component.scss')],
  host: { class: ""},
})
export class TimelineIncidentComponent implements OnInit {

  constructor() { }

  @Input() status: Status[] =[];
  
  ngOnInit(): void {
  }  

}